import React from 'react';
import styled from 'styled-components';
import Anchor from 'ls-common-client/dist/components/Anchor';
import Container from 'ls-common-client/src/components/Container';
import Divider from '../../../v2/components/UI/Divider';

const StyledAnchor = styled(Anchor)`
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  vertical-align: baseline;
  background: rgba(255, 255, 255, 0);
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.55;
  font-family: Circular, sans-serif;
  color: inherit;
  font-weight: 400;
  max-width: 100%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 5px;
`;

const StyledDropDownAnchor = styled(StyledAnchor)`
  padding-right: 15px;
`;

const StyledContainer = styled(Container)`
  padding: 0.5rem 1rem;
  border-radius: 1.25rem;
  &:hover {
    cursor: pointer;
    background: #f8f8f8;
    color: #285aff;
  }
`;
const StyledDropDownContainer = styled(Container)`
  padding: 0.5rem 1rem;
  border-radius: 0.75rem;
  &:hover {
    background-color: #eaefff;
    color: #285aff;
  }
`;

const DropDown = styled(Container)`
  border-radius: 1.25rem;
  background-color: #ffffff;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.3);
  padding: 0.75rem 1rem;
`;
const DropDownWrapper = styled(Container)`
  display: none;
  position: absolute;
  right: 0px;
  top: 100%;
  padding-top: 7px;
`;
const NavContainer = styled(Container)`
  padding: 0.5rem 1rem;
  position: relative;
  border-radius: 1.25rem;
  i {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translateY(-40%) rotate(0deg);
    transition: transform 0.3s ease;
    font-size: 25px;
  }
  &:hover {
    background: #f8f8f8;
    cursor: pointer;
    i {
      transform: translateY(-50%) rotate(180deg);
    }
    ${StyledDropDownAnchor}, i {
      color: #285aff;
    }
    ${DropDownWrapper} {
      display: block;
    }
  }
`;

const NavItem = ({ item }) => {
  return (
    <>
      {item.childItems ? (
        <NavContainer>
          <StyledDropDownAnchor href={item.href}>
            {item.label}
          </StyledDropDownAnchor>
          <i className="icon-generalcaretdownmedium" />
          <DropDownWrapper>
            <DropDown>
              {item.childItems.map((child, i) => (
                <>
                  <StyledDropDownContainer onClick={child.onClick}>
                    <StyledAnchor href={child.href}>{child.label}</StyledAnchor>
                  </StyledDropDownContainer>
                  {i !== item.childItems.length - 1 && (
                    <Divider margin="0.35rem 0" thin />
                  )}
                </>
              ))}
            </DropDown>
          </DropDownWrapper>
        </NavContainer>
      ) : (
        <StyledContainer onClick={item.onClick}>
          <StyledAnchor href={item.href}>{item.label}</StyledAnchor>
        </StyledContainer>
      )}
    </>
  );
};

export default NavItem;
